module.exports = __webpack_public_path__ + "img/1.8391c2a1.jpg";